module.exports = __webpack_public_path__ + "img/link05_sp.bef88817.png";